export default function(el, binding) {
	el.scrollIntoView({behavior: 'smooth', block: 'start'})
}
